// extracted by mini-css-extract-plugin
export default {"recos":"k3-z","productCardOverride":"l3-z","rowHasBadge":"m3-z"};